import * as React from 'react';
import range from 'lodash/range';
import styled from 'styled-components';

import useStyles from './styles';

const FORCE = 0.5; // 0-1 roughly the vertical force at which particles initially explode
const SIZE = 12; // max height for particle rectangles, diameter for particle circles
const FLOOR_HEIGHT = 800; // pixels the particles will fall from initial explosion point
const FLOOR_WIDTH = 1600; // horizontal spread of particles in pixels
const PARTICLE_COUNT = 150;
const DURATION = 3500;
const COLORS = ['#FFC700', '#FF0000', '#2E3191', '#41BBC7'];

const createParticles = (count, colors) => {
  const increment = 360 / count;
  return range(count).map(index => ({
    color: colors[index % colors.length],
    degree: increment * index
  }));
};

const Container = styled.div`
  width: 0;
  height: 0;
  position: relative;
  overflow: visible;
  z-index: 1200;

  ${p => p.rotations && p.rotations.map(rotation => `
    @keyframes ${rotation[0]} {
      to {
        transform: ${rotation[1].transform};
      }
    }
  `)}

  ${p => p.keyframes && p.keyframes.map(keyframe => `
    @keyframes ${keyframe[0]} {
      to {
        transform: ${keyframe[1].transform};
      }
    }
  `)}
`;

const Particle = styled.div`
  & > div {
    position: absolute;
    left: 0;
    top: 0;

    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  ${p => p.motions && p.motions.map(motion => `
    ${motion[0]} {
      animation: ${motion[1].animation};

      & > div {
        width: ${motion[1]['& > div']['width']}px;
        height: ${motion[1]['& > div']['height']}px;
        animation: ${motion[1]['& > div']['animation']};

        &:after {
          animation: ${motion[1]['& > div']['&:after']['animation']};
          background-color: ${motion[1]['& > div']['&:after']['backgroundColor']};
          border-radius: ${motion[1]['& > div']['&:after']['borderRadius'] || 0};
        }
      }
    }
  `)}
`;

function ConfettiExplosion({
  particleCount = PARTICLE_COUNT,
  duration = DURATION,
  colors = COLORS,
  particleSize = SIZE,
  force = FORCE,
  height = FLOOR_HEIGHT,
  width = FLOOR_WIDTH,
  floorHeight,
  floorWidth
}) {
  const particles = createParticles(particleCount, colors);
  const classes = useStyles({
    particles,
    duration,
    particleSize,
    force,
    width: floorWidth || width,
    height: floorHeight || height
  });

  const particlesAnimation = Object.entries(classes.particle);

  return (
    <Container
      rotations={Object.entries(classes.rotation)}
      keyframes={Object.entries(classes.keyframes)}
    >
      {particles.map((particle, i) => (
        <Particle
          id={`confetti-particle-${i}`}
          key={particle.degree}
          motions={particlesAnimation}
        >
          <div></div>
        </Particle>
      ))}
    </Container>
  );
}

export default ConfettiExplosion;



// WEBPACK FOOTER //
// ./src/components/onboarding/ConfettiExplosion.js